import types from "./types";

const initialState = {
  providersDataListRes: {},
  providerCoursesListRes: {},
  providerVideosListRes: {},
  providerCategoryListRes: {},
  providerDetailsRes: {},
  providerCoachingResponse: {},
  coachingDetail: {},
  globalSearchPartners:{},
  globalSearchCoaching:{},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case types.PROVIDERS_LIST_RESPONSE:
      return {
        ...state,
        providersDataListRes: action.payload,
      };
    case types.PROVIDER_COURSES_LIST_RESPONSE:
      return {
        ...state,
        providerCoursesListRes: action.payload,
      };
    case types.PROVIDERS_LIST_CLEAR:
      return {
        ...state,
        providersDataListRes: {},
      };
    case types.PROVIDER_VIDEOS_LIST_RESPONSE:
      return {
        ...state,
        providerVideosListRes: action.payload,
      };
    case types.PROVIDER_CATEGORY_LIST_RESPONSE:
      return {
        ...state,
        providerCategoryListRes: action.payload,
      };
    case types.PROVIDER_DETAIL_RESPONSE:
      return {
        ...state,
        providerDetailsRes: action.payload,
      };
    case types.PROVIDER_COACHING_RESPONSE:
      return {
        ...state,
        providerCoachingResponse: action.payload,
      };
    case types.PROVIDER_COACHING_CLEAR:
      return {
        ...state,
        providerCoachingResponse: {},
      };
    case types.COACHING_DETAIL_RESPONSE:
      return {
        ...state,
        coachingDetail: action.payload,
      };
    case types.COACHING_DETAIL_CLEAR:
      return {
        ...state,
        coachingDetail: {},
      };
      case types.GLOBAL_SEARCH_PARTNERS_RESPONSE:
        return {
          ...state,
          globalSearchPartners: action.payload,
        };
      case types.GLOBAL_SEARCH_PARTNERS_CLEAR:
        return {
          ...state,
          globalSearchPartners: {},
        };
        case types.GLOBAL_SEARCH_COACHING_RESPONSE:
          return {
            ...state,
            globalSearchCoaching: action.payload,
          };
        case types.GLOBAL_SEARCH_COACHING_CLEAR:
          return {
            ...state,
            globalSearchCoaching: {},
          };
    default:
      return state;
  }
};
